import React from 'react';
import BillingAddressSetup from './BillingAddressSetup';
import useRootWorkplace from '../../../../../Modules/Manager/Hooks/useRootWorkplace';
import { useAppContext } from '../../../../../Services/AppContext';
import Loading from '../../../../Loading';

interface Props {
	isSuperAdmin?: boolean;
}

const BillingAddressSetupWrapper: React.FC<Props> = ({ isSuperAdmin }) => {
	const { workplaceId, userData } = useAppContext();
	const { rootWorkplaceId } = useRootWorkplace(workplaceId, userData.id);

	if (!rootWorkplaceId) {
		return <Loading />;
	}

	return (
		<BillingAddressSetup
			rootWorkplaceId={rootWorkplaceId}
			isSuperAdmin={isSuperAdmin}
		/>
	);
};

export default BillingAddressSetupWrapper;
